import { Dimensions, Platform } from "react-native";

/**
 * Determines the number of items per row based on screen size and platform
 * @param itemsPerRow - Maximum desired items per row
 * @returns The actual number of items per row based on screen size
 */
export const getResponsiveItemsPerRow = (itemsPerRow: number): number => {
  const windowWidth = Dimensions.get("window").width;

  if (Platform.OS === "web") {
    return windowWidth > 1200
      ? Math.min(itemsPerRow, 4)
      : Math.min(itemsPerRow, 3);
  } else if (Platform.OS === "ios" || Platform.OS === "android") {
    if (windowWidth > 768) {
      return Math.min(itemsPerRow, 3); // iPad or large devices
    } else {
      return Math.min(itemsPerRow, 2); // Mobile devices
    }
  }
  return itemsPerRow;
};
